/**
 * Global namespace for most components `fade` class.
 */
const fadeClass = 'fade';
export default fadeClass;
